module.exports = __webpack_public_path__ + "img/invigorate-multiple-divine.2cff124a.png";